import React from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { CartItem } from '@/contexts/CartContext';

interface RemoveItemConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  item: CartItem | null;
}

export const RemoveItemConfirmation: React.FC<RemoveItemConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  item
}) => {
  if (!item) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center space-x-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <span>¿Eliminar servicio?</span>
          </AlertDialogTitle>
          <AlertDialogDescription className="text-left">
            ¿Estás seguro de que quieres eliminar{' '}
            <span className="font-medium text-foreground">"{item.title}"</span>{' '}
            de tu carrito?
            {item.quantity > 1 && (
              <span className="block mt-2 text-sm text-muted-foreground">
                Se eliminarán {item.quantity} unidades.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};